/* @flow */

import _timedScheduler from './timedscheduler';
import { logDebug } from './logger';

export const DEFAULT_SCHEDULER = 'timed';

export function getSchedulerObj(
  currentScheduler: ?Scheduler = null
): Scheduler {
  if (currentScheduler && currentScheduler.getName() === DEFAULT_SCHEDULER) {
    return currentScheduler;
  }

  const o = new _timedScheduler(DEFAULT_SCHEDULER);
  // $FlowFixMe[prop-missing]
  logDebug(`Using Scheduler ${o.getName()}`);
  // $FlowFixMe[incompatible-type]
  return o;
}
